<template>
  <!--
    Номер договорного бронирования в таблицах — одним чипом «236 · Выкуп»
    вместо номера и отдельного чипа сбоку (замечание USER 02.10: чип стоял
    «присунутым», номер строки съезжал относительно соседних). Тот же приём,
    что у быстрых и новых бронирований: цветной чип с номером (без иконки —
    решение USER 02.10).
    data-cy — как у RentToOwnChip: e2e ищут метку договора по нему.
  -->
  <v-chip
    :small="small"
    color="deep-purple"
    text-color="white"
    class="rent-to-own-number-chip"
    data-cy="rent-to-own-chip"
    :to="link ? { name: 'BookingCard', params: { id: booking.id } } : undefined"
    :aria-label="`${$t('rent_to_own.chip_label')} ${booking.id}`"
    v-tooltip="tooltip"
  >
    {{ booking.id }}<span class="mx-1">·</span>{{ $t("rent_to_own.chip_label") }}
  </v-chip>
</template>

<script>
export default {
  name: "RentToOwnNumberChip",
  props: {
    booking: { type: Object, required: true },
    // Ячейка без ссылки (карточка клиента, архив открывают бронирование по строке).
    link: { type: Boolean, default: true },
    small: { type: Boolean, default: false },
  },
  computed: {
    // Подсказка с номером филиала — как у соседних чипов номера.
    tooltip() {
      if (this.booking.number == null) return null;
      return {
        content: `${this.$t("custom.number")} ${this.booking.number}`,
        placement: "bottom-center",
        targetClasses: ["it-has-a-tooltip"],
        delay: { show: 500, hide: 500 },
      };
    },
  },
};
</script>

<style scoped>
/* Чип — ссылка: подчёркивание и цвет ссылки router-link внутри не нужны. */
.rent-to-own-number-chip {
  text-decoration: none;
}
</style>
